<template>
  <div class="animated fadeIn">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-6 col-md-8">
              <kendo-datepicker class="form-control" v-model="date" format="dd-MM-yyyy"></kendo-datepicker>
            </div>
            <div class="col-6 col-md-4 text-right">
              <div class="btn-group" style="height: 40px">
                <button class="btn btn-secondary" type="button" @click="refresh">
                  Get Report!
                </button>
                <button type="button" class="btn btn-lg btn-secondary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <button class="dropdown-item" @click="sendToSlack">Send to Slack</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <kendo-pivotdatasource ref="dailyreport"
          :transport-read="dailyReport"
          :schema-cube="schema"
          :measures="measures">
        <kendo-pivot-column :name="'type'"></kendo-pivot-column>
        <kendo-pivot-column :name="'channel'"></kendo-pivot-column>
        <kendo-pivot-row :name="'product'"></kendo-pivot-row>
      </kendo-pivotdatasource>
      <div class="row m-0">
        <kendo-pivotconfigurator id="configurator"
            class="d-none d-md-block col-md-2 p-0"
            :data-source-ref="'dailyreport'"
            :filterable="true"
            :height="600">
        </kendo-pivotconfigurator>
        <kendo-pivotgrid id="pivotgrid"
            class="col-2 col-md-10 p-0"
            :data-source-ref="'dailyreport'"
            :filterable="true"
            :columnWidth="200"
            :height="600">
        </kendo-pivotgrid>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { PivotGrid } from '@progress/kendo-pivotgrid-vue-wrapper'

export default {
  data () {
    return {
      date: moment().format('DD-MM-YYYY'),
      measures: ['Gross Sales'],
      schema: {
        dimensions: {
          type: { caption: 'Sales Type' },
          channel: { caption: 'Channel' },
          product: { caption: 'Product' }
        },
        measures: {
          'Gross Sales': { field: 'total', aggregate: 'sum', format: '{0:c}' },
          'Quantity': { field: 'quantity', aggregate: 'sum', format: '{0:n}' }
        }
      }
    }
  },
  components: {
    PivotGrid
  },
  created () {
    // set culture
    window.kendo.culture('id-ID')
  },
  methods: {
    refresh () {
      console.log('refreshing chart ..')
      console.log(this.$refs.dailyreport)
      this.$refs.dailyreport.kendoDataSource.read()
    },
    dailyReport (event) {
      var vm = this
      var date = moment(vm.date, 'DD-MM-YYYY').format('YYYYMMDD')
      vm.axios.get('api/report/sales/daily/?date=' + date)
        .then(
          (response) => {
            console.log(response)
            var orderCode = ''
            for (var i = 0; i < response.data.length; i++) {
              if (orderCode !== response.data[i].order_code) {
                orderCode = response.data[i].order_code
                response.data[i].total = response.data[i].sales + response.data[i].shipping
              } else {
                response.data[i].total = response.data[i].sales
              }
            }
            event.success(response.data)
          }
        )
    },
    sendToSlack () {
      var uri = window.location.href
      var urls = uri.split('/')

      var vm = this
      var data = new URLSearchParams()
      data.append('type', 'DAILY')
      data.append('date', moment(vm.date, 'DD-MM-YYYY').format('YYYYMMDD'))
      data.append('redirect_uri', urls[0] + '//' + urls[2] + '/public/report')
      data.append('channel', 'SLACK')
      vm.axios.post('api/report/public/', data)
        .then(
          (response) => {
            vm.$parent.showNotification('Daily report successfully sent', 'success')
          }
        )
        .catch(
          (error) => {
            console.log(error)
            vm.$parent.showNotification('Oops! Unable to submit data at this moment. Please try again later!', 'danger')
          }
        )
    }
  }
}
</script>

<style>
  .hidden-on-narrow {
    display: inline-block;
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/views/report/DailyReport.vue